import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { Subscription } from 'rxjs/Subscription';
import { Component, Injector, OnDestroy, OnInit, ViewChild, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { CellClickedEvent, GridOptions } from 'ag-grid';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { BtnsForGridService } from 'app/utils/btns-for-grid/btns-for-grid.service';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import * as moment from 'moment';
import { BilledService } from '../billed.service';
import { PaginatorCustomService } from 'app/utils/paginator-custom/paginator-custom.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { BillingEditService } from 'app/core/services/billing-edit.service';
import { FormatCurrencyHelper } from 'app/core/helpers/format-currency-helper';
import { IResponCharges, ITripBillingInfo } from 'app/core/interfaces/billing.interface';
import { constant } from 'app/app.constants';
import { TabsDenialsEnum } from 'app/core/enums/tabs-denials-enum';
import { RiderService } from 'app/pages/riders/rider.service';
import { BooleanCheckDisabledComponent } from 'app/pages/A2-utils/grid-components/boolean-check-disabled/boolean-check-disabled.component';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { GridLayoutStore, moduleActionIdOf } from 'app/utils/grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-denial-grid',
  templateUrl: './denial-grid.component.html',
  styleUrls: ['./denial-grid.component.scss']
})
export class DenialGridComponent extends ParentModule implements OnInit, OnDestroy, AfterViewChecked {
  gridOptions: GridOptions;
  gridCredits: GridOptions;
  gridCharges: GridOptions;
  gridRiderPayor: GridOptions;
  pendingRiderPayorData: any = null;
  subscriptions: Subscription[] = [];
  tripData: any;
  isOpenAppRidersCreate: boolean;
  dataCurrentModule: any = {};
  @ViewChild('modalExportReservation') modalExportReservation: T2CardComponent;
  @ViewChild('modalBillingInfo') modalBillingInfo: T2CardComponent;
  tabsDenials = constant.DENIALS.TABS_DENIALS;
  activatedTab: TabsDenialsEnum = TabsDenialsEnum.Details;
  private shouldOpenBillingInfo = false;
  private shouldEmitRider = false;
  public reversing = false;
  public tripId: number;
  public billingInfo: ITripBillingInfo;
  public rideridInput: number;
  public brokerId: number;

  constructor(
    protected Inject: Injector,
    private btnsForGridService: BtnsForGridService,
    private billedService: BilledService,
    private paginatorCustomService: PaginatorCustomService,
    private sweetAlertHelper: SweetAlertHelper,
    private  billingServices: BillingEditService,
    protected riderService: RiderService,
    protected newReservationService: ReservationService,
    private layoutStore: GridLayoutStore
  ) {
    super('app-billed', Inject);
    this.initGrid();
    this.createGrid();
  }

  ngOnInit() {
    this.initSubscribe();
    this.initLayoutMenu();
  }

  private initLayoutMenu() {
    this.subscriptions.push(this.layoutStore.follow(this.actionsList$, () => ({
      grid: this.gridOptions,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, 'DenialGrid'),
      title: 'Billed Denials'
    })));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngAfterViewChecked(): void {
    if (this.shouldOpenBillingInfo && this.modalBillingInfo) {
      if (this.tripData && this.tripData.tripid && this.tripData.riderid) {
        this.modalBillingInfo.open();
        this.getChargesAndCreditsByTrip(
          this.tripData.tripid,
          this.reversing,
          this.tripData.riderid
        );
      }
      this.shouldOpenBillingInfo = false;
    }
    if (this.shouldEmitRider && this.tripData && this.tripData.riderid && this.modalBillingInfo) {
      this.newReservationService.riderSelected$.emit(this.tripData.riderid);
      if (this.activatedTab === this.tabsDenials.Eligibility) {
        this.getRiderPayorDetail(this.tripData.riderid);
      }
      this.shouldEmitRider = false;
    }
  }

  onChangeTabs(selectedTab: TabsDenialsEnum) {
    this.activatedTab = selectedTab;
    if (this.activatedTab  === this.tabsDenials.Details) {
       this.shouldOpenBillingInfo = true;
    }
    if (this.activatedTab === this.tabsDenials.Eligibility && this.tripData && this.tripData.riderid) {
      this.shouldEmitRider = true;
    }
  }

  isActiveTabDenial(tabsActive: TabsDenialsEnum): boolean {
    return this.activatedTab === tabsActive;
  }

  initSubscribe(): void {
    this.paginatorCustomService.getRowSelected(null);
    this.openModalAssignCategory();
    this.subscriptions.push(
      this.billedService.closeModal$.subscribe((val: boolean) => {
        if (val) {
          if (
            this.modalExportReservation &&
            this.modalExportReservation.isOpen
          ) {
            this.modalExportReservation.close();
          }
          if (this.modalBillingInfo && this.modalBillingInfo.isOpen) {
            this.modalBillingInfo.close();
          }
          this.billedService.triggerCloseModal(false);
        }
      })
    );
    this.subscriptions.push(
      this.actionsList$.subscribe(() => {
        this.disabledSaveLayout(this.isAllowedAction('DenialGrid'));
      })
    );
    this.subscriptions.push(
      this.billedService.dataDenials$.subscribe((data) => {
        if (data && this.gridOptions.api) {
          this.gridOptions.api.setRowData(data);
          if (this.gridCharges && this.gridCharges.api && this.gridCredits && this.gridCredits.api) {
            this.gridCharges.api.setRowData([]);
            this.gridCredits.api.setRowData([]);
          }
          this.rideridInput = null;
          this.setRowDisplayed();
        }
      })
    );
    this.subscriptions.push(
      this.btnsForGridService.clearFilterGrid$.subscribe((filter) => {
        if (filter && this.gridOptions.api) {
          const filterForGrid = {
            'filter': () => this.gridOptions.api.setFilterModel(null),
            'sort': () => this.gridOptions.api.setSortModel(null),
            'saveLayoutGrid': () => this.saveLayout()
          };
          return filterForGrid[filter]();
        }
      })
    );
    this.subscriptions.push(this.actions.asObservable().subscribe((res) => {
      if (res) {
        this.dataCurrentModule = res;
        this.getLayout();
      }
    }));
    this.subscriptions.push(
      this.billedService.exporToExcel.subscribe((res: boolean) => {
        if (res && this.gridOptions.api) {
          this.gridOptions.api.exportDataAsExcel({ sheetName: 'denials', fileName: 'denials' });
        }
      })
    );
  }

  disabledSaveLayout(disabledBtn): void {
    this.btnsForGridService.btnDisabled({ type: 'layout', disabled: disabledBtn });
  }

  formatterAmountMoney = (params: any) => {
    const value = params && params.value ? params.value : 0;
    return _currencyFormat(value);
  }

  formatterDate(params) {
    if (params) {
      return moment(params).format('MM-DD-YYYY');
    }
  }

  public onChangeReversing(): void {
    if (this.tripData && this.tripData.tripid && this.tripData.riderid) {
      this.getChargesAndCreditsByTrip(this.tripData.tripid, this.reversing, this.tripData.riderid);
    }
  }

  getChargesAndCreditsByTrip(tripId: number, inactive: boolean, riderId?: number): void {
    if (!this.gridCharges || !this.gridCharges.api || !this.gridCredits || !this.gridCredits.api) { return; }
    this.gridCharges.api.setRowData([]);
    this.gridCredits.api.setRowData([]);
    this.subscriptions.push(
      Observable.forkJoin(
        this.billingServices.getCreditsByTrip(tripId, inactive),
        this.billingServices.getChagesByTrip(tripId, inactive)
      ).pipe(
        finalize(() => { this.rideridInput = riderId; })
      ).subscribe({
        next: ([credits, charges]: [any, IResponCharges]) => {
          if (credits) {
            this.gridCredits.api.setRowData(credits);
          }

          if (charges && charges.tripcharge) {
            this.gridCharges.api.setRowData(charges.tripcharge);
            this.billingInfo = charges.tripbilling;
            this.billingInfo.tripid = charges.tripbilling.tripid ? charges.tripbilling.tripid : tripId;
            this.updateTripInMainGrid(this.billingInfo.tripid, charges.tripbilling);
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        }
      })
    );
  }

  updateTripInMainGrid(tripId: number, tripBilling: ITripBillingInfo): void {
    const api = this.gridOptions.api;
    if (!api) {
      return;
    }

    const node = api.getRowNode(String(tripId));

    if (!node) {
      return;
    }

    node.setDataValue(
      'schedulename',
      tripBilling.billingschedule
        ? tripBilling.billingschedule
        : node.data.schedulename
    );

    node.setDataValue(
      'denialcategory',
      tripBilling.denialcategory
        ? tripBilling.denialcategory
        : node.data.denialcategory
    );
  }


  createGrid() {
    this.gridCharges = this.buildBaseGridOptions();
    this.gridCredits = this.buildBaseGridOptions();
    this.settingGrid(this.gridCharges, false);
    this.settingGrid(this.gridCredits, true);
  }

  buildBaseGridOptions(): GridOptions {
    return {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'single',
      onGridReady: (params) => {
        if (params && params.api) {
          params.api.setRowData([]);
        }
      }
    };
  }

  settingGrid(grid: GridOptions, isCredit: boolean) {
    grid.columnDefs = this.defineColumns(isCredit);
  }

  defineColumns(credit?: boolean) {
    return [
      {
        headerName: 'Seq',
        field: 'sequence',
        colId: 'sequence',
        cellRenderer: (params) => {
          return params.rowIndex + 1;
        },
        width: 50
      },
      {
        headerName: 'CPT/MOD',
        field: 'cptmodifiers',
        colId: 'cptmodifiers',
        width: 60,
        hide: credit,
      },
      {
        headerName: 'Charge Description',
        field: 'charge.description',
        colId: 'charge',
        width: 140,
        hide: credit,
      },
      {
        headerName: 'Qty',
        field: 'units',
        colId: 'units',
        width: 60,
        hide: credit,
        cellStyle: {textAlign: 'center'},
      },
      {
        headerName: 'Credit',
        field: 'credit.description',
        colId: 'credit',
        width: 118,
        hide: !credit,
      },
      {
        headerName: 'Unit Price',
        field: 'unitamount',
        colId: 'unitamount',
        width: 75,
        hide: credit,
        cellStyle: { textAlign: 'right' },
        cellRenderer: function (params: { data: { unitamount: number; }; }) {
          return FormatCurrencyHelper.formatCurrency(params.data.unitamount);
        }
      },
      {
        headerName: credit ? 'Amount' : 'Price',
        field: 'amount',
        colId: 'amount',
        width: 75,
        cellStyle: { textAlign: 'right' },
        cellRenderer: function (params: { data: { amount: number; }; }) {
          return FormatCurrencyHelper.formatCurrency(params.data.amount);
        }
      },
      {
        headerName: 'Chrg',
        field: 'tripcharge.charge.description',
        colId: 'credit',
        width: 100,
        hide: !credit,
        cellRenderer: (params: { data: { tripcharge: { charge: { description: any; }; }; }; }) => {
          if (params && params.data && params.data.tripcharge) {
            return params.data.tripcharge.charge.description;
          }
        }
      },
      {
        headerName: 'Denial code',
        field: 'denial.denialcode',
        colId: 'denialcode',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Denial Code Description',
        field: 'denial.description',
        colId: 'credit',
        width: 100,
        hide: !credit
      },
      {
        headerName: 'Check #',
        field: 'checknumber',
        colId: 'checknumber',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Check Date',
        field: 'checkdateformatted',
        colId: 'checkdateformatted',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Deposit Date',
        field: 'depositdateformatted',
        colId: 'depositdateformatted',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Post Date and Time',
        field: 'modifiedonformatted',
        colId: 'modifiedonformatted',
        width: 130,
        cellStyle: {textAlign: 'center'},
      },
      {
        headerName: 'Reversing',
        field: 'isactive',
        colId: 'isactive',
        width: 57,
        cellStyle: {textAlign: 'center'},
        cellRenderer: function (params: { data: { isactive: any; }; }) {
          return params.data.isactive ? 'No' : 'Yes';
        }
      },
      {
        headerName: 'User',
        field: 'userprofile.fullname',
        colId: 'userprofile',
        width: 169,
      },
    ];
  }

  openModalAssignCategory() {
    this.billedService.openModalAssignCategory$.subscribe((value: boolean) => {
      if (value && this.gridOptions && this.gridOptions.api) {
        const rowSelected = this.gridOptions.api.getSelectedRows();
        if (!rowSelected || !rowSelected.length) {
          this.sweetAlertHelper.captureException('Please select a record.');
          return;
        }
        const ids = rowSelected.map((row) => row.tripid);
        if (!ids || !ids.length) {
          this.sweetAlertHelper.captureException('Error Please Check.');
          return;
        }
        this.billedService.setTripIds(ids);
      }
    });
    this.billedService.triggerOpenModalAssignCategory(false);
  }

  initGrid() {
    this.gridOptions = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple',
      getRowNodeId: (data: any) => String(data.tripid),
      columnDefs: [
        {
          colId: 'id',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          width: 30,
          maxWidth: 30,
        },
        {
          headerName: 'Reservation',
          field: 'consecutive',
          width: 70
        },
        {
          headerName: 'DOS',
          field: 'dateofservice',
          width: 80,
          valueGetter: (params) => {
            if (params && params.data) {
              return this.formatterDate(params.data.dateofservice);
            }
          }
        },
        {
          headerName: 'Rider',
          field: 'fullname',
          width: 100
        },
        {
          headerName: 'DOB',
          field: 'dob',
          width: 60,
          valueGetter: (params) => {
            if (params && params.data) {
              return this.formatterDate(params.data.dob);
            }
          }
        },
        {
          headerName: 'Gender',
          field: 'gender',
          width: 30
        },
        {
          headerName: 'Payor',
          field: 'payor',
          width: 80
        },
        {
          headerName: 'Payor Authorization',
          field: 'payorauthorization',
          width: 80
        },
        {
          headerName: 'Service',
          field: 'service',
          width: 80
        },

        {
          headerName: 'Leg',
          field: 'leg',
          width: 30
        },
        {
          headerName: 'Aging',
          field: 'aging',
          width: 80,
          valueGetter: (params) => {
            if (params && params.data) {
              return this.formatterDate(params.data.aging);
            }
          }
        },
        {
          headerName: 'Total Miles',
          field: 'totalmiles',
          width: 40,
        },
        {
          headerName: 'Total Amount',
          field: 'totalamount',
          width: 80,
          cellRenderer: this.formatterAmountMoney
        },
        {
          headerName: 'Billing Schedule',
          field: 'schedulename',
          width: 90
        },
        {
          headerName: 'Claim #',
          field: 'icn',
          width: 85
        },
        {
          headerName: 'Denial Category',
          field: 'denialcategory',
          width: 80
        },
      ],
      onGridReady: () => {
        this.gridOptions.api.setRowData([]);
      },
      onFilterChanged: (params) => {
        if (params && params.api) {
          this.btnsForGridService.btnDisabled({ type: 'filter', disabled: params.api['filterManager'].advancedFilterPresent });
        }
      },
      onSortChanged: () => {
        const sort = this.gridOptions.api.getSortModel();
        this.btnsForGridService.btnDisabled({ type: 'sort', disabled: !!sort.length });
      },
      onRowDoubleClicked: (params) => {
        if (params && params.data) {
          this.tripData = params.data;
          this.modalExportReservation.open();
        }
      },
      onFilterModified: () => {
        this.setRowDisplayed();
      },
      onRowClicked: (params) => {
        if (params && params.data && params.data.tripid) {
          this.tripData = params.data;
          this.rideridInput = null;
          this.brokerId = this.tripData.brokerid;
          this.shouldOpenBillingInfo = true;
          this.shouldEmitRider = true;
          if (!this.modalBillingInfo || !this.modalBillingInfo.isOpen) {
            this.activatedTab = this.tabsDenials.Details;
          }
        }
      },
    };
    this.gridRiderPayor = <GridOptions>{
      enableFilter: true,
      enableSorting: true,
      enableColResize: true,
      suppressRowTransform: true,
      rowSelection: 'single',

      columnDefs: [
        {
          headerName: 'Payor',
          field: 'description',
          colId: 'square',
          width: 200,
          rowSpan: (params) => {
            return params.data && params.data.rowSpan ? params.data.rowSpan : 0;
          },
          cellStyle: { background: 'white' },
        },
        {
          cellClass: 't2-cursorPointer textAlignCenter',
          headerName: 'Def',
          field: 'isdefault',
          colId: 'isdefault',
          width: 60,
          cellRendererFramework: BooleanCheckDisabledComponent,
          rowSpan: (params) => {
            return params.data && params.data.rowSpan ? params.data.rowSpan : 0;
          },
          cellStyle: { background: 'white' },
        },
        {
          headerName: 'Policy',
          field: 'memberid',
          colId: 'cube',
          width: 90,
          rowSpan: (params) => {
            return params.data && params.data.rowSpan  ? params.data.rowSpan : 0;
          },
          cellStyle: { background: 'white' },
        },
        {
          headerName: 'Medicaid',
          field: 'medicaidnumber',
          colId: 'medicaidnumber',
          width: 90,
          rowSpan: (params) => {
            return params.data && params.data.rowSpan ? params.data.rowSpan : 0;
          },
          cellStyle: { background: 'white' },
        },
        {
          headerName: 'Plan Id',
          field: 'planid',
          colId: 'planid',
          width: 130,
          cellRenderer: (params) => {
            if (!params || !params.data) {
              return '';
            }
            const { planid, longdescription } = params.data;
            if (planid && longdescription) {
              const ico = '<i class="fa fa-info-circle color-primary" aria-hidden="true"></i>';
              return `${ico} ${planid}`;
            }
            return planid ? `${planid}` : '';
          },
        },
        {
          headerName: 'Start Date',
          field: 'startdateformatted',
          colId: 'startdate',
          width: 85,
        },
        {
          headerName: 'End Date',
          field: 'expirationdateformatted',
          colId: 'expirationdate',
          width: 85,
        },
        {
          headerName: 'Health',
          field: 'health',
          colId: 'health',
          width: 90,
        },
        {
          headerName: 'Non-Health',
          field: 'nonhealth',
          colId: 'nonhealth',
          width: 100,
        },
        {
          headerName: 'LTC',
          field: 'isltc',
          colId: 'isltc',
          width: 60,
          cellRendererFramework: BooleanCheckDisabledComponent,
        },
        {
          headerName: 'DUAL',
          field: 'isdual',
          colId: 'isdual',
          width: 80,
          cellRendererFramework: BooleanCheckDisabledComponent,
        },
      ],
      onGridReady: () => {
        if (this.gridRiderPayor && this.gridRiderPayor.api) {
          if (this.pendingRiderPayorData) {
            this.gridRiderPayor.api.setRowData(
              this.rowSpan(this.pendingRiderPayorData)
            );
            this.pendingRiderPayorData = null;
          }
        }
      },
      onCellClicked: (event: CellClickedEvent) => {
        if (event) {
          this.onCellClickedPlanId(event);
        }
      },
    };
  }

  onCellClickedPlanId(event: CellClickedEvent) {
    const { longdescription, planid } = event.data;
    if (planid && longdescription) {
      this.sweetAlertHelper.createCustomAlert(
        {
          title: `Plan Id - ${planid}`,
          text: `${longdescription}`,
          type: 'info',
        }
      );
    }
  }

  loadGrid(data: any) {
    if (this.gridRiderPayor && this.gridRiderPayor.api) {
      this.gridRiderPayor.api.setRowData(this.rowSpan(data));
    } else {
      this.pendingRiderPayorData = data;
    }
  }

  getRiderPayorDetail(riderId: number) {
    this.riderService.getRiderPayorDetail(riderId).subscribe({
      next: (value) => {
        this.loadGrid(value);
      },
      error: (err) => {
        this.sweetAlertHelper.captureException(err);
      },
    });
  }

  rowSpan(data: any) {
    data.map((item: { riderpayorid: any; rowSpan: any }, index: any) => {
      if (
        index ===
        data.findIndex(
          (elem: { riderpayorid: any }) =>
            elem.riderpayorid === item.riderpayorid
        )
      ) {
        item.rowSpan = data.filter((value: { riderpayorid: any }) => {
          return value.riderpayorid === item.riderpayorid;
        }).length;
      }
      return item;
    });
    return data;
  }

  setRowDisplayed(): void {
    if (this.gridOptions && this.gridOptions.api) {
      const filterRows = this.gridOptions.api.getDisplayedRowCount();
      this.paginatorCustomService.getRowSelected(filterRows);
    }
  }

  getLayout(): void {
    const moduleId = this.dataCurrentModule.moduleid;
    this.subscriptions.push(
      this.billedService.getRoleActionByModule(moduleId).subscribe(
        data => {
          data.forEach((val: any) => {
            if (val.action.description === 'DenialGrid' && val.layout) {
              this.gridOptions.columnApi.setColumnState(JSON.parse(val.layout.config));
            }
          });
        }, (error) => {
          this.sweetAlertHelper.captureException(error).then(() => {
          });
        }
      ));
  }

  saveLayout(): void {
    if (this.gridOptions.columnApi.getColumnState().length) {
      const MODULE_ACTION_ID = this.dataCurrentModule.actions.DenialGrid.moduleactionid;
      const stringLayout = JSON.stringify(this.gridOptions.columnApi.getColumnState());
      const data = { moduleactionid: MODULE_ACTION_ID, config: stringLayout };
      this.btnsForGridService.saveLayoutGrid(data);
    }
  }

  updateGeneral() {
    if (this.tripData && this.tripData.tripid && this.tripData.riderid) {
      this.rideridInput = null;
      this.getChargesAndCreditsByTrip(this.tripData.tripid, this.reversing, this.tripData.riderid);
    }
  }

  get titleModal(): string {
    if (this.tripData) {
      const { consecutive, leg, fullname } = this.tripData;
      if (consecutive && leg && fullname) {
        return `Reservation # ${consecutive} - Leg ${leg} - ${fullname}`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billed/denial-grid/denial-grid.component.ts